import React, { useEffect, useState } from 'react';
import { ShieldCheck, Zap, Lock, CreditCard } from 'lucide-react';
export function Pricing() {
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        }; // Reset for demo
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="bg-white py-20 px-4" data-id="element-185">
      <div className="max-w-5xl mx-auto" data-id="element-186">
        <div className="text-center mb-12" data-id="element-187">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-188">
            ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
          </h2>

          <div className="flex justify-center gap-4 text-4xl md:text-6xl font-bold text-gray-900 mb-4" data-id="element-189">
            <div className="flex flex-col items-center" data-id="element-190">
              <span data-id="element-191">{String(timeLeft.hours).padStart(2, '0')}</span>
              <span className="text-sm text-gray-500 font-normal mt-1" data-id="element-192">HS</span>
            </div>
            <span data-id="element-193">:</span>
            <div className="flex flex-col items-center" data-id="element-194">
              <span data-id="element-195">{String(timeLeft.minutes).padStart(2, '0')}</span>
              <span className="text-sm text-gray-500 font-normal mt-1" data-id="element-196">
                MIN
              </span>
            </div>
            <span data-id="element-197">:</span>
            <div className="flex flex-col items-center" data-id="element-198">
              <span data-id="element-199">{String(timeLeft.seconds).padStart(2, '0')}</span>
              <span className="text-sm text-gray-500 font-normal mt-1" data-id="element-200">
                SEG
              </span>
            </div>
          </div>

          <p className="text-red-600 font-bold text-lg" data-id="element-201">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* Pack selection card */}
        <div className="max-w-xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 p-6 md:p-8 mb-10" data-id="element-202">
          <div className="text-center mb-8" data-id="element-203">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-204">
              Elegí tu Pack:
            </h3>
            <p className="text-gray-500 text-base md:text-lg" data-id="element-205">
              Ambas opciones incluyen los 6 Bonos estratégicos
            </p>
          </div>

          <div className="space-y-4 mb-8" data-id="element-206">
            {/* Pack Profesional */}
            <button type="button" onClick={() => setSelected('pro')} className={`w-full text-left rounded-2xl p-5 border-2 transition-colors flex items-center gap-4 ${selected === 'pro' ? 'border-[#1B4D2E] bg-green-50' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-207">
              <span className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-[#1B4D2E]' : 'border-gray-300'}`} data-id="element-208">
                {selected === 'pro' && <span className="w-3 h-3 rounded-full bg-[#1B4D2E]" data-id="element-209" />}
              </span>
              <div className="flex-grow" data-id="element-210">
                <h4 className="text-lg font-bold text-gray-900 leading-tight" data-id="element-211">
                  📘 PACK PROFESIONAL
                </h4>
                <p className="text-sm text-gray-500" data-id="element-212">14 Tomos + 6 Bonos</p>
              </div>
              <div className="text-right" data-id="element-213">
                <div className="text-gray-400 line-through text-sm" data-id="element-214">
                  $29.990
                </div>
                <div className="text-2xl font-bold text-gray-900" data-id="element-215">$18.990</div>
              </div>
            </button>

            {/* Megapack Élite */}
            <button type="button" onClick={() => setSelected('elite')} className={`w-full text-left rounded-2xl p-5 border-2 transition-colors flex items-start gap-4 ${selected === 'elite' ? 'border-[#FFD700] bg-[#FFFBEB]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-216">
              <span className={`flex-shrink-0 w-6 h-6 mt-1 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-[#1B4D2E]' : 'border-gray-300'}`} data-id="element-217">
                {selected === 'elite' && <span className="w-3 h-3 rounded-full bg-[#1B4D2E]" data-id="element-218" />}
              </span>
              <div className="flex-grow" data-id="element-219">
                <h4 className="text-lg font-bold text-gray-900 leading-tight mb-2" data-id="element-220">
                  🏆 MEGAPACK ÉLITE
                </h4>
                <div className="flex flex-wrap gap-2 mb-2" data-id="element-221">
                  <span className="inline-block bg-[#FFD700] text-[#1B4D2E] font-bold px-3 py-0.5 rounded-full text-xs" data-id="element-222">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="inline-block bg-green-100 text-green-700 font-bold px-3 py-0.5 rounded-full text-xs" data-id="element-223">
                    AHORRÁS $11.000
                  </span>
                </div>
                <p className="text-sm text-gray-500" data-id="element-224">
                  14 Tomos + 6 Bonos + 2 EBOOKS ÉLITE
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-225">
                <div className="text-gray-400 line-through text-sm" data-id="element-226">
                  $49.990
                </div>
                <div className="text-2xl font-bold text-[#1B4D2E]" data-id="element-227">$27.990</div>
              </div>
            </button>
          </div>

          <button className="w-full py-5 rounded-2xl font-bold text-lg md:text-xl bg-[#84CC16] hover:bg-[#65A30D] text-white transition-colors shadow-lg flex items-center justify-center gap-2" data-id="element-228">
            {selected === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE →' : 'SÍ, QUIERO EL PACK PROFESIONAL →'}
          </button>
          <p className="text-center text-sm text-gray-500 italic mt-4" data-id="element-229">
            La opción más elegida por entrenadores de rugby argentinos
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-gray-600 font-medium" data-id="element-230">
          <div className="flex items-center gap-2" data-id="element-231">
            <Lock size={18} className="text-green-600" data-id="element-232" />
            <span data-id="element-233">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-234">
            <Zap size={18} className="text-green-600" data-id="element-235" />
            <span data-id="element-236">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-237">
            <ShieldCheck size={18} className="text-green-600" data-id="element-238" />
            <span data-id="element-239">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-240">
            <CreditCard size={18} className="text-green-600" data-id="element-241" />
            <span data-id="element-242">Tarjeta · Transferencia</span>
          </div>
        </div>
      </div>
    </section>;
}